import { Text } from '@/components/atoms/text';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface DimensionTagProps {
  opportunityCount: number;
  riskCount: number;
}

export const DimensionTag = ({ opportunityCount, riskCount }: DimensionTagProps) => {
  const theme = useTheme();

  const totalSelected = opportunityCount + riskCount;

  if (totalSelected === 0) return null;

  const opportunityPart = opportunityCount > 0 ? opportunityCount : '';
  const riskPart = riskCount > 0 ? riskCount : '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {opportunityCount > 0 && (
        <Text
          variant="body2"
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '2px',
            padding: theme.spacing(0.25, 1),
            backgroundColor: theme.palette['mint-green'][100],
            color: theme.palette.text.primary,
          }}
        >
          {opportunityPart}
        </Text>
      )}

      {riskCount > 0 && (
        <Text
          variant="body2"
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '2px',
            padding: theme.spacing(0.25, 1),
            backgroundColor: theme.palette.orange[100],
            color: theme.palette.text.primary,
          }}
        >
          {riskPart}
        </Text>
      )}
    </Box>
  );
};
